export const translation = {
  // Navigation
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    guides: 'Guides',
    shoppingGuide: 'Einkaufsguide',
    about: 'Über uns',
    contact: 'Kontakt',
    searchPlaceholder: 'Produkte, Kategorien, Guides suchen...',
  },

  // Language selector
  lang: {
    en: 'English',
    pt: 'Português',
    de: 'Deutsch',
    current: 'Deutsch',
  },

  // Hero Section
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Unabhängiger Guide • Aktualisiert',
    h1: 'CSSBuy Spreadsheet: Finden, vergleichen und recherchieren Sie Produkte mit mehr Vertrauen',
    subtitle: 'Erkunden Sie eine unabhängige CSSBuy Spreadsheet-Ressource mit organisierten Listen, Kategorien, Kaufguides, QC-Informationen, Lagern, Versand und Sicherheit — alles an einem Ort.',
    ctaPrimary: 'CSSBuy Spreadsheet Erkunden',
    ctaSecondary: 'Hauptseite Besuchen',
  },

  // Categories Section
  categories: {
    h2: 'CSSBuy Spreadsheet nach Kategorie erkunden',
    subtitle: 'Durchsuchen Sie unsere organisierten Produktkategorien und finden Sie die Ressourcen, die Sie für Ihren nächsten Kauf benötigen.',
    viewAll: 'Alle Kategorien anzeigen',
    items: {
      shoes: 'Schuhe',
      hoodies: 'Hoodies/Pullover',
      tshirts: 'T-Shirts',
      jackets: 'Jacken',
      pants: 'Hosen/Shorts',
      headwear: 'Kopfbedeckungen',
      sets: 'Sets',
      underwear: 'Unterwäsche',
      jersey: 'Trikots',
      accessories: 'Accessoires',
      bags: 'Taschen',
      belts: 'Gürtel',
      perfumes: 'Parfüms',
      other: 'Sonstiges',
    },
  },

  // Products Section
  products: {
    title: 'Ausgewählte Produkte aus Kakobuy Spreadsheet',
    subtitle: 'Durchsuchen Sie unsere kuratierte Sammlung verifizierter Produkte. Klicken Sie auf einen Artikel, um Details anzuzeigen und auf der Hauptseite zu kaufen.',
    viewAll: 'Alle in {{category}} anzeigen',
    buyNow: 'Jetzt Kaufen',
  },

  // Dropdown
  dropdown: {
    label: 'Kategorie wählen',
    placeholder: 'Wählen Sie eine Produktkategorie...',
  },

  // Main CTA Buttons
  cta: {
    cssbuySpreadsheet: 'CSSBuy Spreadsheet',
    buyItNow: 'Jetzt Kaufen',
  },

  // Guide Section
  guide: {
    h2: 'Starten Sie mit unserem CSSBuy Spreadsheet Guide',
    text: 'Lernen Sie, wie Sie Produkte recherchieren, Optionen vergleichen und QC-, Lager- und Versandinformationen organisierter verstehen.',
    cta: 'Vollständigen Guide Lesen',
  },

  // Review Section
  review: {
    h2: 'CSSBuy Review: Was Sie wissen sollten',
    text: 'Konsultieren Sie unsere unabhängige Rezension über den Kaufprozess, QC, Lagerung, Versand, Kosten und wichtige Punkte für neue Nutzer.',
    cta: 'CSSBuy Review Lesen',
  },

  // Shipping Section
  shipping: {
    h2: 'CSSBuy Shipping Cost: Verstehen Sie, was den Preis beeinflusst',
    text: 'Die internationalen Versandkosten variieren je nach Ziel, Gewicht, Volumen, Versandmethode, Verpackung und anderen Bedingungen. Lernen Sie, wie Sie die Kosten recherchieren, bevor Sie Ihr Paket versenden.',
    cta: 'Shipping Cost Guide anzeigen',
  },

  // Trust section
  trust: {
    tag1: 'Unabhängige Ressource',
    tag2: 'Mehrsprachige Guides',
    tag3: 'Organisierte Recherche',
    tag4: 'Aktualisierter Inhalt',
  },

  // FAQ
  faq: {
    h2: 'Häufig gestellte Fragen',
    q1: 'Was ist CSSBuy Spreadsheet?',
    a1: 'Eine organisierte Ressource zum Recherchieren und Vergleichen von Produkten, Kategorien und Informationen zum Kaufprozess.',
    q2: 'Ist CSSBuy Spreadsheet offiziell?',
    a2: 'Nein. Diese Website ist eine unabhängige Ressource und wird nicht von CSSBuy betrieben, gesponsert oder unterstützt.',
    q3: 'Ist CSSBuy legitim?',
    a3: 'Konsultieren Sie unseren unabhängigen Guide über Legitimität, Sicherheit, Zahlungen, QC und Versand.',
    q4: 'Wie viel kostet CSSBuy Versand?',
    a4: 'Die Kosten hängen von Ziel, Gewicht, Volumen, Route und Paketmerkmalen ab.',
    q5: 'Wo finde ich CSSBuy Spreadsheet?',
    a5: 'Verwenden Sie unser nach Kategorien und Guides organisiertes Verzeichnis.',
  },

  // Final CTA
  finalCta: {
    h2: 'Bereit, smarter zu recherchieren?',
    text: 'Erkunden Sie das CSSBuy Spreadsheet, vergleichen Sie Informationen und finden Sie die richtigen Guides für Ihre nächste Recherche.',
    ctaPrimary: 'CSSBuy Spreadsheet Erkunden',
    ctaSecondary: 'Hauptseite Besuchen',
  },

  // Footer
  footer: {
    disclaimer: 'CSSBuy Spreadsheet ist eine unabhängige Informationsressource und ist nicht mit CSSBuy verbunden, von CSSBuy unterstützt oder von CSSBuy betrieben.',
    nav: {
      spreadsheet: 'CSSBuy Spreadsheet',
      guide: 'Spreadsheet Guide',
      list: 'Spreadsheet Liste',
      finds: 'Spreadsheet Finds',
      review: 'Review',
      shipping: 'Versand',
      qc: 'QC',
      warehouse: 'Lager',
      safety: 'Sicherheit',
      faq: 'FAQ',
      blog: 'Blog',
      editorial: 'Redaktionsrichtlinien',
      about: 'Über uns',
      contact: 'Kontakt',
      privacy: 'Datenschutz',
      terms: 'Nutzungsbedingungen',
      disclaimer: 'Haftungsausschluss',
    },
  },

  // SEO / Page titles
  seo: {
    homeTitle: 'CSSBuy Spreadsheet | Unabhängiger Ressourcen-Hub & Recherche-Guide',
    homeDesc: 'Unabhängige CSSBuy Spreadsheet-Ressource mit organisierten Produktkategorien, Kaufguides, Reviews, Versandkosten, QC-Infos und Sicherheitstipps.',
  },

  // Blog / Articles
  blog: {
    h2: 'Neueste CSSBuy Spreadsheet Guides',
    subtitle: 'Erkunden Sie unsere Hauptguides zu Produktrecherche, Reviews, Versand, QC, Lager, Sicherheit und mehr.',
    readMore: 'Artikel lesen',
    updatedLabel: 'Zuletzt aktualisiert',
    backHome: 'Zurück zur Startseite',
    relatedTitle: 'Verwandte Guides',
    article1: {
      title: 'CSSBuy Spreadsheet 2026: Vollständiger Guide zur Produktrecherche',
      excerpt: 'Lernen Sie, wie Sie CSSBuy Spreadsheet für organisierte Produktrecherche, Kategorienvergleich und fundierte Kaufentscheidungen nutzen.',
      date: 'August 2026',
    },
  },

  // General
  general: {
    independentNotice: 'Unabhängige Ressource — Nicht mit CSSBuy verbunden.',
  },
};

export default translation;